(function () {
    var activateOverlayHeader = () => {
        var mainContent = document.getElementById("MainContent");
        var sections = mainContent.querySelectorAll(".shopify-section");

        if (sections.length > 0) {
            var firstSection = sections[0];
            var overlayElement = firstSection.querySelector("[data-header-overlay]");
            var headerSection = document.querySelector(".shopify-section-header");
            var breadcrumb = document.querySelector(".breadcrumb");

            var removeBackgroundClasses = (element) => {
                let classList = element.getAttribute("class");
                classList = classList.replace(/color-background-\d+/g, "");
                element.setAttribute("class", classList);
            };

            if (overlayElement && overlayElement.hasAttribute("data-header-overlay")) {
                // Wir ignorieren jetzt die Header-Group-Überprüfung komplett
                firstSection.classList.add("section--has-overlay");
                firstSection.classList.remove("not-margin");
                headerSection.classList.add("color-background-overlay");

                if (breadcrumb) {
                    removeBackgroundClasses(breadcrumb);
                    var colorScheme = overlayElement.getAttribute("data-color-scheme");
                    if (colorScheme) {
                        breadcrumb.classList.add("color-" + colorScheme);
                    }
                }
            } else {
                headerSection.classList.remove("color-background-overlay");
                if (breadcrumb) removeBackgroundClasses(breadcrumb);
            }
        }
    };

    activateOverlayHeader();
    document.addEventListener("DOMContentLoaded", activateOverlayHeader);
    document.addEventListener("shopify:section:load", activateOverlayHeader);
    document.addEventListener("shopify:section:unload", activateOverlayHeader);
    document.addEventListener("shopify:section:reorder", activateOverlayHeader);
})();